var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "success" }, [
    _c("img", {
      staticClass: "image_success",
      attrs: { src: require("@/assets/image/image_success.png"), alt: "" },
    }),
    _c("div", [
      _c(
        "p",
        {
          staticStyle: {
            "font-weight": "bold",
            color: "green",
            "font-size": "20px",
            "line-height": "36px",
          },
        },
        [_vm._v(_vm._s(_vm.$t("payment_successful_text")) + "!")]
      ),
      _c("p", [
        _c("span", [_vm._v(_vm._s(_vm.currTimer) + "s")]),
        _c(
          "a",
          {
            staticClass: "color",
            on: {
              click: function ($event) {
                return _vm.toIndex()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("home_page_text")))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }